{
  "actions": "Eylemler",
  "hideButtonLabel": "Daha az göster",
  "showAllButtonLabel": "Tümünü göster ({tagCount, number})"
}
